import React from 'react';
import Badge from 'react-bootstrap/Badge';
import {FilterSelections, FilterSelection} from '../../../../types/Search';
import {AggregationType} from "../../../../types/AggregationType";
import BaseProps from "../../../../types/BaseProps";
import classNames from "classnames";

import './SelectedFilters.scss';

type SelectedFiltersProps = BaseProps & {
  selection: FilterSelections;
  onDeselect: (deselected: Array<string>) => void;
};

/**
 * Component which renders list items representing selected filters. Each item has a label and
 * a button which allows item to be removed from selection.
 */
export default class SelectedFilters extends React.Component<SelectedFiltersProps> {

  removeAll = () => {
    this.props.onDeselect(Object.keys(this.props.selection));
  }

  render() {
    const classes = classNames("SelectedFilters", this.props.className);
    const selection = this.props.selection;
    const selectionKeys = Object.keys(selection);
    return <div className={classes}>
      {
        selectionKeys.map((key: string) => {
          const selected = selection[key];
          return <Badge variant="secondary" key={key} className="selected-filter">
            <SelectionTitle selection={selected}/>
            <button type="button" className="close" title="Remove from selection"
                    onClick={() => this.props.onDeselect([key])}>
              <span>&times;</span>
            </button>
          </Badge>
        })
      }
      {(selectionKeys.length > 1) ? <ClearAllButton onClick={this.removeAll} /> : null}
    </div>
  }
}

/**
 * Component for selection title. Title is build based on facet/aggregation type
 * @param props
 * @constructor
 */
const SelectionTitle = (props: { selection: FilterSelection }) => {
  const selection = props.selection;
  let selectionTitle;
  switch (selection.facetType) {
    case AggregationType.DATERANGE:
      selectionTitle = `${selection.field} (${selection.value.startDate}-${selection.value.endDate})`;
      break;
    case AggregationType.NUMERIC_RANGE:
      selectionTitle = `${selection.field} (${selection.value.min}-${selection.value.max})`;
      break;
    case AggregationType.KEYWORD:
      selectionTitle = `${selection.field} (${selection.value})`;
      break;
  }
  return <span className="title">
        {selectionTitle}
      </span>
};

/**
 * A button for clearing all selected filters.
 */
const ClearAllButton = (props: {
  onClick: () => void
}) => {
  return <button className="btn btn-link btn-clear-all ml-1" onClick={props.onClick}>Clear all</button>;
};
